import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'xp-dot',
	standalone: true,
	template: '',
	styleUrls: ['./xp-dot.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpDotComponent {}
